// src/utils/authRedirect.js

// Get the intended redirect URL from URL parameters
export const getRedirectUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const redirect = urlParams.get('redirect');
  
  if (redirect) {
    return decodeURIComponent(redirect);
  }
  
  return '/dashboard';
};

// Set the redirect URL to localStorage
export const setRedirectUrl = (url) => {
  localStorage.setItem('redirectAfterLogin', url);
};

// Clear the redirect URL from localStorage
export const clearRedirectUrl = () => {
  localStorage.removeItem('redirectAfterLogin');
};

// Check if current path is a test route that requires authentication
export const isTestRoute = (pathname) => {
  return pathname.startsWith('/test-mcq/') || pathname.startsWith('/test-coding/');
};

// Get the full current URL for redirect
export const getCurrentUrl = () => {
  return window.location.pathname + window.location.search;
};

// Validate redirect URL to prevent security issues
export const validateRedirectUrl = (url) => {
  // Only allow internal routes
  if (!url || !url.startsWith('/')) {
    return '/dashboard';
  }
  
  // Prevent redirect to login/register to avoid loops
  if (url.includes('/login') || url.includes('/register')) {
    return '/dashboard';
  }
  
  return url;
}; 